import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";

export const ButtonWithLabel = () => (
  <>
    <span className="flex size-5">
      <Icon
        aria-label={t("spaces.bookmarks.add_link")}
        size={16}
        type="plus-v2"
      />
    </span>
    <Typography.LabelSm weight="medium">
      {t("spaces.bookmarks.add_link")}
    </Typography.LabelSm>
  </>
);
